// extracted by mini-css-extract-plugin
export default {"layout":"ImportEntries_layout__KF5u4","description":"ImportEntries_description__Gn4Du"};